import { useEffect, useState } from "react";
import { getSettings } from "../../../../services/settingsServices";

const DEFAULT_SETTINGS = {
  nom_club: "",
  shortname_club: "",
  logo_club: "",
  adresse_club: "",
  tel_club: "",
  mail_club: "",
  facebook_club: "",
  instagram_club: "",
};

export const useClubSettings = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchSettings = async () => {
      try {
        setLoading(true);

        const data = await getSettings();
        const nextSettings = Array.isArray(data) && data.length > 0 ? data[0] : {};

        if (!cancelled) {
          setSettings({
            ...DEFAULT_SETTINGS,
            ...nextSettings,
          });
        }
      } catch (error) {
        console.error("Erreur getSettings:", error);

        if (!cancelled) {
          setSettings(DEFAULT_SETTINGS);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchSettings();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    settings,
    loading,
  };
};